import type { KeyboardEvent } from 'react';

/** Stops Enter in a text field from submitting the form; only the save button submits. */
export const preventEnterSubmit = (event: KeyboardEvent<HTMLFormElement>) => {
  if (event.key === 'Enter' && event.target instanceof HTMLInputElement) {
    event.preventDefault();
  }
};
